import React, { Component } from "react";
import styles from "../../assets/css/modules/help/help-section.css";
import Accordion from "../shared/Accordion";
import Content from "../../content/Content";
import printStyle from "../../assets/css/modules/print.css";

export default class HelpSection extends Component {
  render() {
    return (
      <div
        className={`help-section ${styles.sectionSpacing}`}
        role="region"
        aria-label="help"
      >
        <div className={styles.HelpLink + " " + printStyle.noprint}>
          {/* <Link
            to={this.props.HeadingLinkTo}
            className={styles.HelpLink + " " + printStyle.noprint}
          > */}
            {/* {this.props.Healthsupportline === "Healthsupportline" ? "": 
            (this.props.HeadingLinkText=== "FAQs" || this.props.HeadingLinkText=== "HELP" ? '':<i className="icon-question_mark" />)} */}
           {(this.props.Healthsupportline === "Healthsupportline" || this.props.HeadingLinkText=== "FAQs" || this.props.HeadingLinkText=== "HELP") ? "": ""} 
           {this.props.HeadingLinkText}
          {/* </Link> */}
          </div>
        <div className={styles.w65Responsive + " " + styles.accordionWrapper}>
          {this.props.HelpSet &&
            this.props.HelpSet.map((qnAnswerItem, index) => (
              <Content
                key={index}
                names={[qnAnswerItem.Answer, qnAnswerItem.Question]}
              >
                {(answer, question) => (
                  <Accordion question={question} answer={answer} />
                )}
              </Content>
            ))}
        </div>
        {/* <div
          className={styles.cardLink + " " + printStyle.noprint}
        >
          {this.props.MoreHelpLinkText} 
          {this.props.Healthsupportline === "Healthsupportline" ? "": <span className="ml-2">➔</span>}
        </div> */}
      </div>
    );
  }
}
